module.exports = __webpack_public_path__ + "static/media/degrees.7ce60334.xlsx";